import { SelectOption, Team } from "@velaro/velaro-component-lib";
import React from "react";

export const TeamsContext = React.createContext<{
  teams: Team[];
  teamOptions: SelectOption[];
  getTeamNameById: (teamId: number) => string;
  getTeamByName: (teamName: string) => Team | null;
  setTeams: (teams: Team[]) => void;
  getTeamById: (TeamId: number) => Team | null;
}>({
  teams: [],
  teamOptions: [],
  getTeamNameById: () => "",
  getTeamByName: () => null,
  setTeams: () => {},
  getTeamById: () => null
});
